import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dcf7d15"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "text-left -ml-2 mr-2 col-6 -ml-2 w-3rem inline-block" }
const _hoisted_3 = { class: "col-6 -ml-2 w-6rem p-0 inline-block" }

import { AnyFn, Fn, get, set, useDateFormat } from "@vueuse/core";
import Listbox from "primevue/listbox";
import { inject, onBeforeMount, ref, withDefaults, computed } from "vue";
import { CUSTOMER_NAME_MENU_LIMIT } from "@/clinic/typings/constants/booking";
import { IBooking } from "@/clinic/typings";
import TimeUtils from "@/clinic/utils/time-utils";
import { Dictionary, EventImpl } from "@fullcalendar/core/internal";
import { EventClickArg, EventInput } from "@fullcalendar/core";
import { BookingActionEnum } from "@/clinic/typings/enums/booking";

type IMenuItem = {
  event: EventImpl;
  isLastItem: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'menu',
  props: {
    event: null,
    isLastItem: { type: Boolean }
  },
  setup(__props: any, { expose }) {

const props = __props as { event: EventImpl, isLastItem: boolean };


const onShowBookingSidebar = ref<AnyFn>();

const selectedItem = ref<IBooking | null>(null);

const menuList = ref();

const extendedProps = computed((): Dictionary => props.event.extendedProps);

const isLastItem = get(props).isLastItem;

const customerName = (customer_name: string): string => {
  return customer_name?.length > CUSTOMER_NAME_MENU_LIMIT
    ? `${customer_name.slice(0, CUSTOMER_NAME_MENU_LIMIT).trim()}...`
    : customer_name;
};

const eventMedicalIdClass = computed((): string => `event-medical-${get(extendedProps).medicalMenuId}`);

const removeZIndexAuto = () => {
  const [timelineEvent] = document.querySelectorAll(".fc .fc-timeline-events") as unknown as Element[];
  timelineEvent?.classList?.remove("z-auto");
};

const removeZIndexClass = () => {
  const [eventEl] = document.getElementsByClassName(get(eventMedicalIdClass));
  eventEl?.classList?.remove("z-5");
};

const hideMenu = () => {
  if (!get(menuList)) return;

  removeZIndexClass();
  removeZIndexAuto();
  get(menuList)?.classList.add("hidden");
};

const getMenu = computed((): HTMLElement => get(menuList));

const onMenuClick = (bookingId: number) => {
  const event = props.event;
  const showBookingSidebarFn =
    get(onShowBookingSidebar) ||
    ((_booking: IBooking, _action: string, _eventArg: EventClickArg | EventInput) => ({
      _booking,
      _action,
      _eventArg,
    }));
  showBookingSidebarFn({ id: bookingId } as IBooking, BookingActionEnum.show, { event } as EventClickArg);
  hideMenu();
};

onBeforeMount(() => set(onShowBookingSidebar, inject<Fn>("onShowBookingSidebar")));
// eslint-disable-next-line no-undef
expose({
  getMenu,
  hideMenu,
  eventMedicalIdClass,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "menuList",
    ref: menuList,
    class: "menu-event-times relative font-normal hidden z-3"
  }, [
    _createVNode(_unref(Listbox), {
      modelValue: selectedItem.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedItem).value = $event)),
      options: _unref(get)(_unref(extendedProps))?.bookings,
      class: _normalizeClass(['menu-event-list', 'absolute', 'top-0', _unref(isLastItem) ? 'right-100' : 'left-100', 'w-10rem'])
    }, {
      option: _withCtx(({ option: { start_time, end_time, customer_name, id } }) => [
        _createElementVNode("div", {
          class: "text-xs p-1 m-0 grid-nogutter mr-2 ml-2 text-right w-9rem",
          onClick: ($event: any) => (onMenuClick(id))
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(customerName(customer_name)), 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(get)(_unref(useDateFormat)(new Date(_unref(TimeUtils).toLocalTime(start_time.toString())), "HH:mm"))) + " ~ " + _toDisplayString(_unref(get)(_unref(useDateFormat)(new Date(_unref(TimeUtils).toLocalTime(end_time.toString())), "HH:mm"))), 1)
        ], 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["modelValue", "options", "class"])
  ], 512))
}
}

})